module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-12-a876565101f7b9fe70b7cc748bfd5f21.png";